module.exports = __webpack_public_path__ + "static/images/renwu.82a482e.jpg";